// removed by extract-text-webpack-plugin
module.exports = {"centeredContainer":"_1n4CBH3T7Gr67r-noaBHy0","link":"_1xy-2ff8SWYYfEnxBYV0B7","alert":"VSIQSchTl3D01LKMVCcrY","tableWrapper":"_4YD5MYxjtoNJN4DP3kzt1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/userinvoices/UserInvoices.scss
// module id = 1655
// module chunks = 0